import { render, staticRenderFns } from "./WeekNumberPicker.vue?vue&type=template&id=37529a7e"
import script from "./WeekNumberPicker.vue?vue&type=script&lang=js"
export * from "./WeekNumberPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports